export default __webpack_public_path__ + "static/media/app.66c6c6a1.svg";